/**
 * Redondea la posición del panel de un overlay del CDK: la deja fraccionaria cuando su origen lo es,
 * y el borde y el texto se ven corridos medio píxel (las listas y ventanas de DevExtreme caían en
 * píxeles enteros).
 */
export function snapToPixels(pane: HTMLElement): void {
  for (const side of ['top', 'bottom', 'left', 'right'] as const) {
    const value = pane.style[side];
    if (value.endsWith('px')) pane.style[side] = `${Math.round(parseFloat(value))}px`;
  }
}
